import {DataService} from '../Services/data.service';
import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {WebSocketService} from '../Services/webSocket.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Person} from '../Model/Person';
import {Role} from '../Model/Role';

@Component({
  selector: 'app-telfort',
  templateUrl: './telfort.component.html',
  styleUrls: ['./telfort.component.css'],
})

export class TelfortComponent implements OnInit {
  users = [];
  newPerson: Person = {personId: 0, druppelId: '', name: '', role: null, password: '', enabled: false , fullName : ''};

  name: string;
  password: string;
  password2: string;
  fullName: string;
  error;
  submitted = false;
  today;


  constructor(private dataService: DataService, public webSocketService: WebSocketService, private router: Router, private modalService: NgbModal) {
    this.today = new Date();
    console.log(this.dataService.role);
    this.checkRole();
  }

  /**
   * Check the role of the logged in {@link Person}
   */
  checkRole(): void {
    if (this.dataService.role.id !== 8) {
      this.router.navigateByUrl('aanmelden');
    }
  }

  /**
   * ngOnInit() is called on start-up
   * Will get all {@link PersonLunch} that had lunch today and add them to the overview
   * Will also get the amount of {@link PersonLunch} that are subscribed to today's lunch
   * After this, it will setup the websocket
   */
  ngOnInit(): void {
    this.getTelfortUsers()
  }

  getTelfortUsers(): void {
    this.dataService.getTelfortEmployees().then((data) => {
      console.log(data);
      for(var i = 0; i<data.length; i++ ) {
        data[i].password = '';
        data[i] = data[i];
      }
      this.users = data;
    });
  }

  enableOrDisable(person: Person): void {
    this.dataService.setTelfortEmployeeDisabled(person).then((data) => {
      console.log(data);
      this.getTelfortUsers();
    })
  }

  resetPassword(person: Person): void {
    this.dataService.resetPassword(person).then((data) => {
      console.log(data);
      this.getTelfortUsers();
    })
  };

  /**
   * on submitting the page use the login function
   */
  onSubmit() {
    this.error = '';
    if(this.name != '' && this.password != '' && this.password2 != '' && this.fullName != '') {
      if(this.password === this.password2) {
        this.submitted = true;
        this.submitNewTelfortUser(this.name, this.password , this.fullName);
      } else {
        this.error = "De twee wachtwoorden komen niet overeen";
      }
    } else {
      this.error = "Vul alle velden in";
    }
  }

  submitNewTelfortUser(name: string, password: string , fullname: string) {
      this.newPerson.name = name;
      this.newPerson.role = {id: 2, role: "Medewerker Telfort"};
      this.newPerson.password = password;
      this.newPerson.enabled = true;
      this.newPerson.fullName = fullname;
      this.dataService.newTelfortPerson(this.newPerson).then((data) => {
        this.name = '';
        this.password = '';
        this.password2 = '';
        this.submitted = false;
        this.fullName = '';
        console.log(data);
        this.newPerson = {personId: 0, druppelId: '', name: '', role: null, password: '', enabled: false , fullName: ''};
        this.getTelfortUsers();
      });

  }

}



// WEBPACK FOOTER //
// ./src/app/Telfort/telfort.component.ts